module.exports = __webpack_public_path__ + "d69c7d7ec0e5bbc5b27e24fb6a9b668d.svg";